import { isSome } from '@mbfab/shared'

import type { ColumnConfig } from './main-row'

// v1 apps/frontend/client/src/components/MillsheetPrintForm/MillsheetListSvgV2/Footer.tsx の移植（そのまま）
export function Footer({ columnConfigs }: { columnConfigs: ColumnConfig[] }) {
  const messages = [
    columnConfigs.some((x) => x.type === 'manufacturerName' || x.type === 'steelType')
      ? '製造会社ごと及び鋼材の種類（記号）ごとに記入すること。'
      : undefined,
    columnConfigs.some((x) => x.type === 'steelType')
      ? '鋼材の種類（記号）はSD295A, SD345等を記入すること。'
      : undefined,
    columnConfigs.some((x) => x.type === 'size') ? '断面形状はD16, D22等を記入すること。' : undefined,
    '使用した重量を実施重量欄に記入すること。',
  ].filter(isSome)
  return (
    <g id="footer">
      <text
        fill="black"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Hiragino Kaku Gothic"
        fontSize={15}
        fontWeight={800}
        letterSpacing="0em"
      >
        {messages.map((message, i) => {
          const prefix = i === 0 ? '注:   ' : '       '
          return (
            <tspan key={i} x={100} y={1343.2 + i * 23}>
              {prefix}
              {i + 1}
              {'. '}
              {message}
            </tspan>
          )
        })}
      </text>
    </g>
  )
}
